import { Component } from '@angular/core';

@Component({
  selector: 'app-awaiting-access-from-coach',
  standalone: false,
  templateUrl: './awaiting-access-from-coach.component.html',
  styleUrl: './awaiting-access-from-coach.component.scss'
})
export class AwaitingAccessFromCoachComponent {

}
